'use strict';

module.exports = require('./scripts');
